import React from "react"
import Input from "../../components/UI/Input/Input"
import classes from "./Controls.module.css"
import { useTranslation } from "react-i18next"

const Controls = props => {
    const { t } = useTranslation()
    return (
        <div className={classes.Wrapper}>
            <Input title={t("misc:Checker.CurrentSeed")} changed={props.seedValidator} val={props.currentSeed} />
            <Input
                type="number"
                title={t("misc:Checker.StartSlot")}
                val={props.currentStartFrame}
                changed={props.startValidator}
            />
            <Input
                type="number"
                title={t("misc:Checker.NumberOfSlots")}
                val={props.currentNumberOfFrames}
                changed={props.numberValidator}
            />
            <div>
                <button className={classes.Button} onClick={props.calculateResults}>
                    {t("misc:Checker.ButtonDisplayResults")}
                </button>
                <button className={classes.Button} onClick={props.timelineHandler}>
                    {!props.showTimeline ? t("misc:Checker.ButtonShowTimeline") : t("misc:Checker.ButtonHideTimeline")}
                </button>
            </div>
        </div>
    )
}

export default React.memo(Controls)
